var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "787px",
    height: "787px",
    viewBox: "0 0 787 787",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CheckMask") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CheckMask",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#FFFFFF",
    points: "231 601.678918 231 508.647955 242 512 242 574.664861 298 586 305.103383 613.78838"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMask);
export default __webpack_public_path__ + "static/media/CheckMask.7b1dc86cf79b49f0555af1d6c3c6aae1.svg";
export { ForwardRef as ReactComponent };